import { Tag } from '@goldcast/api/backend';

import actions from '@/studio/tags/store/actions';
import mutations from '@/studio/tags/store/mutations';

export interface State {
  tags: TagsMap;
  isFetchingTags: boolean;
  errorFetchingTags: null | Error;
}

export type TagsMap = {
  [id: string]: Tag;
};

export const getInitialState = () => ({
  tags: {} as TagsMap,
  isFetchingTags: false,
  errorFetchingTags: null
});

const state: State = getInitialState();

export default {
  state,
  mutations,
  actions,
  namespaced: true
};
